import React from 'react';
import { Typography } from '@mui/material';
import { titleEditorStoreSelector, useTitleEditorStore } from '@warehouse/title/domain';
import { FieldWrapper } from '../../../../src/views/title/TitleSettings/style';
import TitleTooltip from '../../../../src/components/titles/TitleTooltip';
import { ReadOnlyIdField } from './ReadOnlyIdField';

export function UltraMezzId() {
	const { ultraMezzUuid } = useTitleEditorStore(titleEditorStoreSelector.title);

	if (!ultraMezzUuid) return null;
	return (
		<FieldWrapper className="field-wrapper">
			<Typography variant="buttonLargeMedium">
				UltraMezz ID
				<TitleTooltip path="coreMetadata.contentId" />
			</Typography>
			<ReadOnlyIdField aria-label="UltraMezz ID" variant="buttonMediumRegular">
				{ultraMezzUuid}
			</ReadOnlyIdField>
		</FieldWrapper>
	);
}
